import React from "react";

const BatchVoucherTableHeader = () => {
  return (
    <>
      <tr>
        <th className="align-middle" rowSpan={2}>
          Date
        </th>
        <th className="align-middle" rowSpan={2}>
          Ledger Name
        </th>
        <th className="align-middle" rowSpan={2}>
          Invoice Type
        </th>
        <th className="align-middle" rowSpan={2}>
          Invoice Number
        </th>
        <th rowSpan={1} colSpan={2}>
          Inwards
        </th>
        <th rowSpan={1} colSpan={2}>
          Outwards
        </th>
        <th rowSpan={1} colSpan={2}>
          Closing Balance
        </th>
      </tr>
      <tr>
        <th>Quantity</th>
        <th>Value</th>
        <th>Quantity</th>
        <th>Value</th>
        <th>Quantity</th>
        <th>Value</th>
      </tr>
    </>
  );
};

export default BatchVoucherTableHeader;
